import React, { CSSProperties } from 'react'

const AgTechCloseIcon = (props: { 
    onClicked: (e: React.MouseEvent<HTMLElement>) => Promise<void>,
    classes?: string,
    styles?: CSSProperties,
    size?: number
}) => {
    const iconSize = props.size ?? 36;

    return (
        <i 
            className={`centered fas fa-times clickable color-changing button bg-white bordered rounded text-more text-detail flex ${props.classes ?? ''}`}
            onClick={e => props.onClicked(e)}
            style={{
                height: iconSize,
                width: iconSize,
                lineHeight: iconSize + 'px',
                marginRight: 0,
                ...props.styles
            }}
        />
    )
}

export default AgTechCloseIcon